module.exports = __webpack_public_path__ + "static/media/furniture.e5115271.png";